module.exports = __webpack_public_path__ + "static/media/DataInfoImage.e255cf3a.png";